import {
  TruncatedString,
  formatCurrency,
} from '@quickbit/backoffice-core-frontend';
import { Table } from '@quickbit/qb-design-system';
import { CustodianTransaction } from 'api/useDirectOnrampApi';

interface Props {
  transactions: CustodianTransaction[];
}

export const CustodianTransactionTable = ({ transactions }: Props) => {
  return (
    <Table
      headers={[
        { label: 'Created At', cellKey: 'createdAt', sort: false },
        {
          label: 'Transaction Code',
          cellKey: 'transactionCode',
          sort: false,
        },
        { label: 'Type', cellKey: 'type', sort: false },
        {
          label: 'Account Code',
          cellKey: 'accountCode',
          sort: false,
        },
        { label: 'Amount', cellKey: 'amount', sort: false },
        { label: 'Euro Amount', cellKey: 'euroAmount', sort: false },
        { label: 'Network Fee', cellKey: 'networkFee', sort: false },
        {
          label: 'Blockchain  ID',
          cellKey: 'blockchainTransactionId',
          sort: false,
        },
      ]}
      rows={transactions.map((transaction) => ({
        value: {
          createdAt: transaction.createdAt.toLocaleString(),
          transactionCode: (
            <TruncatedString text={transaction.transactionCode} />
          ),
          type: transaction.type,
          accountCode: transaction.accountCode,
          amount: formatCurrency(transaction.amount),
          euroAmount: formatCurrency({
            amount: transaction.euroAmount,
            currencyCode: 'EUR',
            scale: 0,
          }),
          networkFee: transaction.networkFee.toString(),
          blockchainTransactionId: transaction.blockchainTransactionId && (
            <TruncatedString text={transaction.blockchainTransactionId} />
          ),
        },
      }))}
    />
  );
};
